import React from 'react';

import {AttachmentMedia} from 'src/components/trigger-attachment/attachment-media';
import {TriggerAttachment} from 'src/openapi/models/TriggerAttachment';

import {Dialog, DialogHeader, DialogMain} from '@pb/kit-component-dialog-v2';
import {Group, Item} from '@pb/kit-component-group';
import {formatDate} from '@pb/kit-formatters';

import {fileAttachment, fileAttachmentFullscreenContent} from './trigger-attachment.module.styl';

type Props = {
    attachment: TriggerAttachment | null,
    setFullscreen: (attachment: TriggerAttachment | null) => void,
};

export const AttachmentFullscreen = (props: Props) => {
    const {
        attachment,
        setFullscreen,
    } = props;

    const caption = attachment?.creationDate
        ? `Uploaded on: ${formatDate(attachment.creationDate)}`
        : 'New attachment';

    const onClose = () => {
        setFullscreen(null);
    };

    return (
        <Dialog
            shown={Boolean(attachment)}
            setShown={onClose}>
            {attachment ? (
                <Group direction="v" className={fileAttachment}>
                    <DialogHeader onClose={onClose}>
                        <Group gap="s">
                            <Item> {caption}</Item>
                            <Item>{attachment.active ? '' : '(Inactive)'}</Item>
                        </Group>
                    </DialogHeader>
                    <DialogMain>
                        <Group
                            alignItems="center"
                            justify="center"
                            className={`pdx-l ${fileAttachmentFullscreenContent}`}>
                            <AttachmentMedia
                                isPreview={false}
                                attachment={attachment}
                                controls={true}
                                setFullscreen={setFullscreen}
                            />
                        </Group>
                    </DialogMain>
                </Group>
            ) : null}
        </Dialog>
    );
};
